/**
 * What the API says about the size of a picture it just accepted (`size` in the upload answer of a store logo,
 * a store banner or a product photo — see `image-size-policy.ts` in the API). A picture UNDER the floor never
 * gets here: the API refuses it with a 400 whose message states both sizes. Reaching here with
 * `belowRecommended` means: stored, but small enough that it may look soft once displayed.
 */
export interface ImageSizeVerdict {
  readonly width: number;
  readonly height: number;
  readonly belowRecommended: boolean;
  readonly recommendedWidth: number;
  readonly recommendedHeight: number;
}

/** The params of `merchant.images.belowRecommended`, or `null` when there is nothing to tell the merchant. */
export function belowRecommendedParams(
  fileName: string,
  size: ImageSizeVerdict | undefined,
): Record<string, string> | null {
  if (!size?.belowRecommended) return null;
  return {
    name: fileName,
    width: String(size.width),
    height: String(size.height),
    recommendedWidth: String(size.recommendedWidth),
    recommendedHeight: String(size.recommendedHeight),
  };
}
